const $ = window.jQuery;
const threeCards = $('.three_recent_posts ul');
$(document).ready(function () {
  if (threeCards.length) {
    slickify();

    $(window).resize(function () {
      $('.three_recent_posts ul')[0].slick.refresh();
    });
  }
});

function slickify() {
  $('.three_recent_posts ul').slick({
    centerMode: false,
    slidesToShow: 3,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          centerMode: true,
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          arrows: false,
          centerMode: true,
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  });
}
